"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAPIUrl = void 0;
const joinUrlPath = (...allUrls) => {
    return allUrls.reduce((urls, url) => {
        if (!urls) {
            return url;
        }
        const separator = url[0] !== '/' && urls[urls.length - 1] !== '/' ? '/' : '';
        return urls + separator + url;
    }, '');
};
const getAPIUrl = (path, base, includeAPISection = true) => {
    return includeAPISection ? joinUrlPath(base, '/api', path) : joinUrlPath(base, path);
};
exports.getAPIUrl = getAPIUrl;
//# sourceMappingURL=url.js.map